import React from 'react';
import { Box, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';

const Policy: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        textAlign: 'center',
      }}
    >
      <Typography
        variant='h4'
        sx={{ mb: 2, color: 'text.secondary' }}
      >
        Coming Soon
      </Typography>
      <Typography
        variant='body1'
        color='text.secondary'
      >
        Policy insights and analytics will be available in a future release.
      </Typography>
    </Box>
  );
};

export default Policy;
